export function axFalse() {
    return false;
}
